import { SVGProps } from "react";

const ChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || "8"}
    height={props.height || "14"}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.74995 0.75C6.74995 0.75 0.750013 5.16893 0.75 6.75005C0.749987 8.33116 6.75 12.75 6.75 12.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default ChevronLeft;
